import React, { useContext, useEffect, useState } from 'react';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../components/default/DefaultCard';
import MassiveCommissionChangeContainer from '../WorkOrders/components/MassiveCommissionChangeContainer';
import TransportOrdersDataTable from '../WorkOrders/components/tables/TransportOrderDataTable';
import useTransportOrderService from '../../app/services/hooks/useTransportOrderService';
import { TransportOrderDataForm, TransportOrderFilters } from '../../app/models/TransportOrder';
import { ServiceResponse } from '../../app/services/shared/interfaces';
import { TransportationOrderStatus } from '../../app/models/TransportationOrderStatus';
import { toast } from 'react-toastify';
import useNavigationPage from '../../hooks/useNavigationPage';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Cambio de comisiones masivo',
        url: '/commissions-change',
        isActive: true
    }
];

const CommissionsChange = () => {

    const {
        fetchingGetTransportOrders,
        getTransportOrders,
    } = useTransportOrderService();

    const { navigationPage } = useNavigationPage();

    const [transportOrders, setTransportOrders] = useState<TransportOrderDataForm[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [statuses, setStatuses] = useState<TransportationOrderStatus[]>([]);
    const [columnAlias, setColumnAlias] = useState<string[]>(["Orden de transporte", "Tramo", "Origen", "Destino", "Comisión", "Fecha de Programa", "Estado"]);
    
    const [filter, setFilter] = useState<TransportOrderFilters>({
        page: 1,
        per_page: 10,
        sort: 'program_date',
        order: 'desc',
        table_name: 'transport_order'
    });

    useEffect(() => {
        getAllTransportOrders();
    }, [filter, filter.page, filter.per_page, filter.sort, filter.order]);
    
    const getAllTransportOrders = () => {
        getTransportOrders(filter, {
            onSuccess: (response: ServiceResponse) => {
                setTransportOrders(response.data.transport_orders);
                setStatuses(response.data.statuses ?? []);
                setTotalRows(response.data.total_rows);
                // setColumnAlias(response.data.alias_list)
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2000
                });

                if (response.data.to_dashboard) {
                    navigationPage('/');
                }
            }
        });
    };

    const reloadTable = () => {
        getAllTransportOrders();
    };



    return (
        <>
            <Breadcrumbs pageSection="Cambio de comisiones masivo" breadcrumbs={breadcrumbs} />

            <div className="row">
                <div className="col-md-6">
                    <DefaultCard>
                        <MassiveCommissionChangeContainer
                            filter={filter}
                            setFilter={setFilter}
                        />
                    </DefaultCard>
                </div>
            </div>

            <div className="row">
                <DefaultCard>
                    <TransportOrdersDataTable
                        transportOrders={transportOrders}
                        loading={fetchingGetTransportOrders}
                        totalRows={totalRows}
                        filter={filter}
                        statuses={statuses}
                        setFilter={setFilter}
                        onSearch={reloadTable}
                        columnDict={columnAlias}
                        commissionChange={true}
                    />
                </DefaultCard>
            </div>
        </>
    );
};

export default CommissionsChange;
